var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder
		showPlaceholderProductList: false,
		placeholderProductPerRow: 8
	},
	template: {
		loadMoreButton:'<div id="bc-sf-filter-load-more-button-container"><a href="javascript:;" aria-label="{{label.loadMore}}" class="bc-sf-filter-load-more-button btn btn-secondary">{{label.loadMore}}</a></div>',
	}
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
	// Displaying price base on the policy of Shopify, have to multiple by 100
	soldOut = !data.available; // Check a product is out of stock
	onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Convert images to array
	images = data.images_info;
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;
	// Customize API data to get the Shopify data
	data = prepareShopifyData(data);
	// Add Custom class
	var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	// Add Grid Width class
	itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
	// Add Label
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
	// Add Images
	itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
	// Add Price
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
	// Add Vendor
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
	// itemActiveSwapClass
	var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
	itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
	// Hide price if 0
	var priceClass = data.price_min == 0 && data.price_max == 0 ? 'price-hidden' : '';
	itemHtml = itemHtml.replace(/{{priceClass}}/g, priceClass);

	// Add data json
		itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
	// For List View
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/
	// Get Template
	var itemHtml = bcSfFilterTemplate.productListItemHtml;
	// Customize API data to get the Shopify data
	data = prepareShopifyData(data);
	// Add Custom class
	var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	// Add Label
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
	// Add Images
	itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
	// Add Vendor
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
	// Add Price
	var itemPriceHtml = buildPrice(data, onSale, priceVaries);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
	// Description
	var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
	itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
	// itemActiveSwapClass
	var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
	itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	return itemHtml;
	// End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
	var gridWidthClass = 'xlarge-up--one-quarter one-half';
	return gridWidthClass;
}

function buildImages(data) {
	var html = '';
	// Build Main Image
	var thumbSrc = images.length > 0 ? images[0]['src'] : bcSfFilterConfig.general.no_image_url,
	thumbUrl = bcsffilter.optimizeImage(thumbSrc, '300x300_crop_center'),
	thumbUrlSrcset = bcsffilter.optimizeImage(thumbSrc, '300x300_crop_center') + ' 300w' +
	', ' + bcsffilter.optimizeImage(thumbSrc, '500x500_crop_center') + ' 500w' +
	', ' + bcsffilter.optimizeImage(thumbSrc, '750x750_crop_center') + ' 750w' +
	', ' + bcsffilter.optimizeImage(thumbSrc, '1000x1000_crop_center') + ' 1000w';

	html += '<img src="' + thumbUrl + '" srcset="' + thumbUrlSrcset + '" alt="' + data.title + '" sizes="(min-width: 1440px) 308px, (min-width: 990px) calc((25vw - 22.5px) * 0.91098), (min-width: 750px) calc((50vw - 35px) * 0.91098), calc((50vw - 7.5px) * 0.8889)" />';

	// Build Image Swap
	if (bcSfFilterConfig.custom.active_image_swap) {
		if(images.length > 1) {
			var flipImageSrc = images[1]['src'];
			var flipImageUrl = bcsffilter.optimizeImage(flipImageSrc, '300x300_crop_center'),
			flipImageUrlSrcset = bcsffilter.optimizeImage(flipImageSrc, '300x300_crop_center') + ' 300w' +
			', ' + bcsffilter.optimizeImage(flipImageSrc, '500x500_crop_center') + ' 500w' +
			', ' + bcsffilter.optimizeImage(flipImageSrc, '750x750_crop_center') + ' 750w' +
			', ' + bcsffilter.optimizeImage(flipImageSrc, '1000x1000_crop_center') + ' 1000w';

			html += '<div class="hover-image"><img src="' + flipImageUrl + '" srcset="' + flipImageUrlSrcset + '" alt="' + data.title + '" sizes="(min-width: 1440px) 308px, (min-width: 990px) calc((25vw - 22.5px) * 0.91098), (min-width: 750px) calc((50vw - 35px) * 0.91098), calc((50vw - 7.5px) * 0.8889)" /></div>';
		}
	}
	return html;
}

function buildVendor(data) {
	var html = '';
	if (bcSfFilterConfig.custom.show_vendor) {
		html = bcSfFilterTemplate.vendorHtml;
	}
	return html;
}

function buildPrice(data) {
	var isBullionProduct = false,
	bullionPriceClass = '';

	if(data.template_suffix == 'bullion') {
		isBullionProduct = true;
		bullionPriceClass = ' is-indicative';
	}

	console.log(data)

	var html = '',
	priceMin = bcsffilter.formatMoney(data.price_min, theme.moneyFormat);
	compareAtPriceMin = bcsffilter.formatMoney(data.compare_at_price_min, theme.moneyFormat);
 
	if (bcSfFilterConfig.custom.show_price) {
		// Hide price if 0
		if(data.price_min != 0 && data.price_max != 0) {
			// Round down Bullion product prices 
			if(isBullionProduct) {
				let baseFee = 1;
				priceMin = bcsffilter.formatMoney(Math.ceil(data.price_min / baseFee), theme.moneyFormatBullion);
				
				console.log(priceMin)

				compareAtPriceMin = bcsffilter.formatMoney(Math.ceil(data.compare_at_price_min / baseFee), theme.moneyFormatBullion);
			}

			if (onSale) {
				html += '<p class="price sale' + bullionPriceClass + '">';
				if(isBullionProduct) {
					html += (bcSfFilterConfig.label.indicative_price) + ': ';
				}
				if (priceVaries) {
					html += (bcSfFilterConfig.label_basic.from) + ' ';
				}
				html += '<span itemprop="price">' + priceMin + '</span> ';
				html += '<s>' + compareAtPriceMin + '</s> ';
			} else {
				html += '<p class="price' + bullionPriceClass + '">';
				if(isBullionProduct) {
					html += (bcSfFilterConfig.label.indicative_price) + ': ';
				}
				if (priceVaries) {
					html += (bcSfFilterConfig.label_basic.from) + ' ';
				}
                if(!isBullionProduct) {
                  html += '<span itemprop="price">' + priceMin + '</span>';
                } else {
                  html += '<span itemprop="price" class="bullion-price" data-sku="'+data.selected_or_first_available_variant.sku+'">' + '' + '</span>';
                }
			}
			html += '</p>';
		}
	}
	return html;
}

function fetchBullionPrices() {
	var skus = $('.bullion-price').map(function() {
        return $(this).data('sku');
    }).get();
    var currentCurrency = theme.currency.toUpperCase().slice(0, 3)
    let currency_format = currentCurrency + "${{amount}}";
    var url = `https://asia-northeast1-graceful-fact-313302.cloudfunctions.net/bullion-prices/api/process/rate?currency=${currentCurrency}&sku=${skus.join(",")}`;
    
  	var headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
  	
  	fetch(url, {
      method: 'GET',
      headers: headers,
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      data[0].map(pricing => {
        var selector = `.bullion-price[data-sku="${pricing["SKU"]}"]`;
        $(`.bullion-price[data-sku="${pricing["SKU"]}"]`).text(slate.Currency.formatMoney(pricing["Ask"]*100, currentCurrency.slice(0, 2) + "${{amount}}"))
      })
    }).catch(function() {
      console.log("Booo");
    });
}

function buildLabels(data) {
	var labelOutput = '';

	if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
		labelOutput = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
	} else {
		if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
			labelOutput = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		} else {
			if (data.tags) {
				for (var i = 0; i < data.tags.length; i++) {
					var tag = data.tags[i];
					if (tag.indexOf('Label - ') !== -1) {
						labelOutput = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('Label - ')[1]);
						break;
					}
				}
			}
		}
	}

	// Build labels
	return labelOutput;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}
	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');
		var sortingArr = this.getSortingList();
		if (sortingArr) {
			var paramSort = this.queryParams.sort || '';
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				activeClass = '';
				if(paramSort == k) {
					activeClass = 'active';
				}
				sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ('.bc-sf-filter-custom-sorting').html(html);
			if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
				jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
			}

			var labelSort = '';
			if(paramSort.length > 0) {
				var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
				labelSort = bcSfFilterConfig.label[labelHandle];
			} else {
				labelSort = bcSfFilterConfig.label.sorting;
			}

			// Leave label as 'Sort By'
			//jQ('.bc-sf-filter-custom-sorting label span span').text(labelSort);
		}
	}
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
	var _this = this;
	jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
		e.preventDefault();
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
	});

	jQ(".bc-sf-filter-custom-sorting > label").click(function() {
		var $this = jQ(this),
		$dropdown = $this.next('.bc-sf-filter-filter-dropdown');

		if(!$dropdown.is(':animated')) {
			// Animate on mobile only
			if($dropdown.parent().is('#bc-sf-filter-top-sorting-mobile')) {
				if($dropdown.parent().hasClass('bc-sf-filter-sort-active')) {
					$dropdown.slideUp().parent().removeClass('bc-sf-filter-sort-active');
				} else {
					$dropdown.slideDown().parent().addClass('bc-sf-filter-sort-active');
				}
				jQ('#bc-sf-filter-tree').hide();
			// Just hide/show
			} else {
				if($dropdown.parent().hasClass('bc-sf-filter-sort-active')) {
					$dropdown.hide().parent().removeClass('bc-sf-filter-sort-active');
				} else {
					$dropdown.show().parent().addClass('bc-sf-filter-sort-active');
				}
				jQ('#bc-sf-filter-tree').hide();
			}
		}
	});

	jQ(this.getSelector('filterTreeMobileButton')).click(function(){
		jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
		jQ('#bc-sf-filter-top-sorting-mobile').removeClass('bc-sf-filter-sort-active');
	});
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
	var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
	var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
	var listProductSelector = jQ(this.getSelector('products'));
	topDisplayTypeSelector.html(itemHtml);
	// Active current display type
	topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
	if (this.queryParams.display == 'list') {
		topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
		listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
	} else if (this.queryParams.display == 'grid') {
		topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
		listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
	}
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
	var _this = this;
	var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
	var listProductSelector = jQ(this.getSelector('products'));
	jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
		e.preventDefault();
		_this.internalClick = true;
		jQ(this).parent().children().removeClass('active');
		jQ(this).addClass('active');
		if (_this.queryParams.display == 'list') {
			topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
			listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
		} else if (_this.queryParams.display == 'grid') {
			topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
			listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
		}
		var newUrl = jQ(this).attr('href');
		_this.onChangeData(newUrl, 'display');
	})
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
	if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ(this.selector.topShowLimit).html('');
		var numberList = this.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k = 0; k < arr.length; k++) {
				showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
			}
			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			jQ(this.selector.topShowLimit).html(html);
			// Set value
			jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
		}
	}
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
	if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
		var breadcrumbItemsHtml = '';
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;
			if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
				breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
			} else {
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
			}
		} else {
			breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
		}
		var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
		html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
		jQ(this.selector.breadcrumb).html(html);
	}
};
/************************** END BUILD TOOLBAR **************************/
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
		/* start-initialize-bc-al */
		var self = this;
		var alEnable = true;
		if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
			alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
		}
		if (alEnable === true && typeof BCActionList !== 'undefined') {
				if (typeof bcActionList === 'undefined') {
						bcActionList = new BCActionList();
				}else{
					if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
							bcActionList.initFlag = false;
							bcActionList.alInit(bcSfFilterParams, bcAlParams);
					} else {
							bcActionList.alInit();
					}
				}
		}
		/* end-initialize-bc-al */
	// Call theme init function
	if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
		$(theme.init);
	}
	// End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
	var _this = this;
	var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
	if (data.total_product == 1) {
		totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
	}
	jQ('#bc-sf-filter-total-product').html(totalProduct);

	jQ('body').find('.bc-sf-filter-skeleton-button').remove();

	// Prevent double tap on iOS
	this.isMobile()&&jQ(".bc-sf-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});

	// Fix image not loaded on mobile
	(this.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));
  	fetchBullionPrices();
};


// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/************************** POCKET SQUARE CUSTOM **************************/
// Use existing mobile detection
BCSfFilter.prototype.isMobile = function() {
	return jQ('.mq').width() <= 3;
};

// Moving 'Clear All' button to the bottom
BCSfFilter.prototype.buildFilterSelection = function(a) {
	var b = this.buildFilterSelectionData(a),
		c = b[0],
		d = b[1],
		e = this.buildClearAllButton();
	if ("" != c) {
		var f = this.getTemplate("filterRefineWrapper");
		f = f.replace(/{{label}}/g, this.getSettingValue("label.refine")), f = f.replace(/{{selectedItems}}/g, c), f = this.buildFilterTreeClass(f), this.addFilterTreeItem(f, "after", "vertical"), jQ(this.selector.filterTree).find("." + this.class.filterRefineWrapper + " ." + this.class.filterBlockTitle).append(e)
	}
	var g = this.getSettingValue("general.selectionHorizontalPlace");
	if ("#bc-sf-filter-tree-h" != g && jQ(g).empty(), "" != d) {
		var h = this.getTemplate("filterRefineHorizontalWrapper");
		h = h.replace(/{{label}}/g, this.getSettingValue("label.refine")), h = h.replace(/{{selectedItems}}/g, d), h = this.buildFilterTreeClass(h), "top" == this.getSettingValue("general.refineByHorizontalPosition") ? this.addFilterTreeItem(h, "before", "horizontal", g) : this.addFilterTreeItem(h, "after", "horizontal", g), jQ(".bc-sf-filter-pc." + this.class.filterRefineWrapper).append(e)
	}
};

// Adding $ to Price Slider
BCSfFilter.prototype.buildFilterOptionGeneralRangeSlider = function(a, b, c, d, e, f, g) {
	var h = this,
		i = document.getElementById(a),
		j = g.hasOwnProperty("sliderRange") && null !== g.sliderRange ? parseInt(g.sliderRange) : 4,
		k = g.hasOwnProperty("sliderStep") && null !== g.sliderStep ? parseInt(g.sliderStep) : 1,
		l = g.hasOwnProperty("sliderDelimiter") && null !== g.sliderDelimiter ? g.sliderDelimiter : "",
		m = this.class.filterOptionRange,
		n = g.filterType.indexOf("price") > -1 ? this.getSettingValue("general.decimalPriceRange") : 0;
	if (k <= .1 && (n = 1), k <= .01 && (n = 2), k <= .001 && (n = 3), (f - e < k || null == e || null == f) && this.getSettingValue("general.oneValueRangeSlider")) e -= 1e-4, f += 1e-4, noUiSlider.create(i, {
		start: [c, d],
		connect: !0,
		behaviour: "tap",
		animate: !0,
		animationDuration: 300,
		step: k,
		range: {
			min: e,
			max: f
		}
	}), jQ(i).attr("disabled", " disabled");
	else {
		if (j > 0) {
			for (var o = [], p = 0; p < j; p++) o.push(p * (100 / j));
			o.push(100), noUiSlider.create(i, {
				start: [c, d],
				connect: !0,
				behaviour: "tap",
				animate: !0,
				animationDuration: 300,
				step: k,
				range: {
					min: e,
					max: f
				},
				pips: {
					mode: "positions",
					values: o,
					density: j,
					format: wNumb({
						decimals: n,
						thousand: l,
						prefix: '$',
						edit: function(a) {
							return h.buildShortenPipLabels(a, l)
						}
					})
				}
			}), this.getSettingValue("general.enableSliderRuler") || jQ("#" + a).addClass("no-ruler"), jQ("#" + a).addClass("has-pips"), i.noUiSlider.on("update", function() {
				var b = jQ("#" + a + " .noUi-pips").find(".noUi-marker").last();
				b.hasClass("noUi-marker-normal") && (b.removeClass("noUi-marker-normal"), b.addClass("noUi-marker-large"), b.after('<div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 100.00000%">' + Math.ceil(f) + "</div>"))
			})
		} else noUiSlider.create(i, {
			start: [c, d],
			connect: !0,
			behaviour: "tap",
			animate: !0,
			animationDuration: 300,
			step: k,
			range: {
				min: e,
				max: f
			}
		});
		if (this.slideEvent(a, b, e, f, g), "style1" == this.getSettingValue("general.rangeStyle")) {
			var q = m + "-amount-min",
				r = m + "-amount-max",
				s = this.customizeDisplayRangeValue(c, d, g.filterType, g),
				t = s[0],
				u = s[1];
			jQ("#" + b).find("." + q).val(t), jQ("#" + b).find("." + r).val(u), jQ("#" + b).on("change", "." + q, function() {
				var a = jQ(this).val(),
					c = jQ("#" + b + " ." + r).val();
				i.noUiSlider.set([a, c])
			}), jQ("#" + b).on("change", "." + r, function() {
				var a = jQ(this).val(),
					c = jQ("#" + b + " ." + q).val();
				i.noUiSlider.set([c, a])
			})
		}
		this.setRangeValueEvent(a, e, f, g)
	}
};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

/* start-boost-shopify-multi-currency */
BCSfFilter.prototype.isEnableShopifyMultipleCurrencies=function(){return typeof bcSfFilterConfig!=="undefined"&&bcSfFilterConfig.hasOwnProperty("general")&&bcSfFilterConfig.general.hasOwnProperty("currencies")&&bcSfFilterConfig.general.currencies.length>1&&this.isShopifyActiveCurrency()};BCSfFilter.prototype.isShopifyActiveCurrency=function(){return typeof Shopify!=="undefined"&&Shopify.hasOwnProperty("currency")&&Shopify.currency.hasOwnProperty("rate")&&Shopify.currency.rate!=1};
if(typeof BCSfFilter.prototype.isEnableShopifyMultipleCurrencies == 'function' && BCSfFilter.prototype.isEnableShopifyMultipleCurrencies() === true){
	BCSfFilter.prototype.roundedPrice=function(price){price=parseFloat(price).toFixed(2);var currentCurrency=bcSfFilterConfig.general.current_currency.toLowerCase().trim();var roundRules=this.getSettingValue("currencyRoundingRules");var roundRule=roundRules&&currentCurrency&&roundRules.hasOwnProperty(currentCurrency)?roundRules[currentCurrency]:0;var maxRounding=this.getMinMaxRounding(true);if(maxRounding){var roundRuleTmp=parseFloat(roundRule);roundRuleTmp=roundRuleTmp/maxRounding;price=price/maxRounding;if(roundRuleTmp==1)roundRuleTmp=0;var priceInt=Math.floor(price);var priceDeci=(price-priceInt).toFixed(2);price=priceDeci>roundRuleTmp?priceInt+1:priceInt;price=price*maxRounding;if(roundRuleTmp==0)roundRule=0;price=price+parseFloat(roundRule)}return price};BCSfFilter.prototype.getMinMaxRounding=function(isMax){if(typeof isMax=="undefined")isMax=false;var roundRuleList=[.25,.5,.75,.9,.95,.99,1,25,50,75,90,95,99,100,250,500,750,900,950,999,1e3];var currentCurrency=bcSfFilterConfig.general.current_currency.toLowerCase().trim();var roundRules=this.getSettingValue("currencyRoundingRules");var roundRule=roundRules&&currentCurrency&&roundRules.hasOwnProperty(currentCurrency)?parseFloat(roundRules[currentCurrency]):0;var mulNum=false;if(roundRule>0&&jQ.inArray(roundRule,roundRuleList)!==-1){var mulNum=.99;if(roundRule>100){mulNum=999}else if(roundRule>10){mulNum=99}else if(roundRule>1){mulNum=9}if(isMax){mulNum=roundRule>1?mulNum+1:mulNum+.01}}return mulNum};BCSfFilter.prototype.convertPriceBasedOnActiveCurrency=function(price,isRounded){if(typeof isRounded=="undefined")isRounded=true;if(price===null)return price;if(this.isEnableShopifyMultipleCurrencies()===true){var convertPrice=price*Shopify.currency.rate;if(isRounded){price=this.roundedPrice(convertPrice)}else{price=convertPrice}}return price};BCSfFilter.prototype.revertPriceToDefaultCurrency=function(price,isMin){if(this.isEnableShopifyMultipleCurrencies()===true){price=this.roundedPrice(price);if(isMin){var minRound=this.getMinMaxRounding();if(minRound){price=price-minRound}}price=price/Shopify.currency.rate;return price.toFixed(8)}return price};BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};BCSfFilter.prototype.prepareFilterOptionData=function(data){if((data.filterType=="price"||data.filterType=="variants_price")&&data.values){if(jQ.isArray(data.values)){for(var i=0;i<data.values.length;i++){var under=false,above=false;if(data.values[i].hasOwnProperty("to")){under=true;data.values[i]["to"]=this.convertPriceBasedOnActiveCurrency(data.values[i]["to"])}if(data.values[i].hasOwnProperty("from")){above=true;data.values[i]["from"]=this.convertPriceBasedOnActiveCurrency(data.values[i]["from"])}if(under&&above){data.values[i]["key"]=data.values[i]["from"]+"-"+data.values[i]["to"]}else if(under){data.values[i]["key"]="*-"+data.values[i]["to"]}else{data.values[i]["key"]=data.values[i]["from"]+"-*"}}}else{data.values.min=this.convertPriceBasedOnActiveCurrency(data.values.min);data.values.max=this.convertPriceBasedOnActiveCurrency(data.values.max)}}return data};BCSfFilter.prototype.updateApiParams=function(url){var self=this;var params=this.getFilterParams(url);var paramKeys=Object.keys(params);paramKeys=paramKeys.filter(function(key){return key.indexOf("pf_p_")==0||key.indexOf("pf_vp_")==0});self.activeCurrencyPrices=[];if(paramKeys.length){jQ.each(paramKeys,function(i,key){var priceVal=params[key][0].split(":");priceVal=jQ.map(priceVal,function(val,i){var isMin=i==0?true:false;return val.length==0?"":self.revertPriceToDefaultCurrency(val,isMin)});self.activeCurrencyPrices[key]=params[key];params[key]=[priceVal.join(":")]})}params=this.setDefaultParams(params);if(params.hasOwnProperty("currency")){delete params.currency}if(params.hasOwnProperty("currency_rate")){delete params.currency_rate}this.queryParams=params};BCSfFilter.prototype.pageOverFallback=function(data){if(data.total_product>0&&Array.isArray(data.products)&&data.products.length==0){var limit=this.queryParams.limit||false,curentPage=this.queryParams.page||1,totalPage=Math.ceil(data.total_product/limit);if(limit&&curentPage>1&&curentPage>totalPage){this.queryParams.page=totalPage;var urlW=new URL(window.location.href);if(urlW.searchParams.get("page")!==null)urlW.searchParams["delete"]("page");urlW.searchParams.append("page",totalPage);if(typeof History!=="undefined"){History.replaceState("","",urlW.toString().replace(/\+/g,"%20"));return true}}}return false};BCSfFilter.prototype.afterGetFilterData=function(result,eventType){var self=this;if(!this.pageOverFallback(result)){if(this.activeCurrencyPrices){jQ.extend(self.queryParams,this.activeCurrencyPrices)}this.hideLoading();if(typeof this.removePlaceholderForFilterTree!=="undefined"){this.removePlaceholderForFilterTree()}if(["infinite","load_more"].indexOf(this.getSettingValue("general.paginationType"))>-1&&this.getSettingValue("general.showLoadMoreLoading")&&this.getSettingValue("general.showLoading")===false){this.hideLoadMoreLoading()}if(eventType=="collection"){var openListClass=bcsffilter["class"].filterOptionOpenList,closeListClass=bcsffilter["class"].filterOptionCloseList;if(jQ("."+openListClass).length>0)jQ("."+openListClass).remove();if(jQ("."+closeListClass).length>0)jQ("."+closeListClass).remove()}if(result.hasOwnProperty("errorMessage")){}else{this.catchError(result,eventType);this.buildAll(result,this.queryParams.build_filter_tree,eventType)}}};
}
/* end-boost-shopify-multi-currency */